module.exports = __webpack_public_path__ + "img/google-f-pay.330f1bef.svg";